import { render, staticRenderFns } from "./ReadonlyToggle.vue?vue&type=template&id=5b271066"
import script from "./ReadonlyToggle.vue?vue&type=script&lang=js"
export * from "./ReadonlyToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports